import {findIndex, map} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import EmptyPlaceholder from 'shared/college-earnings/components/empty-placeholder';
import LoadingIndicator from 'shared/college-earnings/components/loading-indicator';
import PlaceholderText from 'shared/college-earnings/components/placeholder-text';
import FollowingHeader from 'shared/college-earnings/components/following-header';
import DiscoverCollegesButton from 'shared/components/discover-colleges-button';
import Earning from './earning';

const RaiseMe = window.Raise;

class CollegeEarnings extends React.Component {
  static propTypes = {
    earnings: PropTypes.array,
    previousEarnings: PropTypes.array,
    loading: PropTypes.bool,
    animating: PropTypes.bool,
    showNewEarnings: PropTypes.bool,
    receiveEarnings: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
    followedCollegeIds: PropTypes.array,
    setEarningFilter: PropTypes.func.isRequired,
    earningFilter: PropTypes.string.isRequired,
    useApplyByTerminology: PropTypes.bool,
  };

  componentDidMount() {
    const {followedCollegeIds, setLoading, receiveEarnings} = this.props;
    this.empty = followedCollegeIds ? !followedCollegeIds.length : false;

    if (this.empty) {
      setLoading(false);
    } else {
      receiveEarnings();
    }

    RaiseMe.vent.on('eval:followed:colleges', () => {
      receiveEarnings();
    });
  }

  render() {
    const {
      earnings,
      loading,
      previousEarnings,
      animating,
      showNewEarnings,
      setEarningFilter,
      earningFilter,
      followedCollegeIds,
      useApplyByTerminology,
    } = this.props;

    if (loading) {
      return <LoadingIndicator />;
    }

    if (this.empty) {
      return <EmptyPlaceholder />;
    }

    const earningNodes = map(earnings, (earning, i) => {
      const prevEarningIndex = findIndex(previousEarnings, ['slug', earning.slug]);
      return (
        <Earning
          key={i}
          earnings={earning}
          useApplyByTerminology={useApplyByTerminology}
          previousEarnings={prevEarningIndex === -1 ? null : previousEarnings[prevEarningIndex]}
          animating={animating}
          showNewEarnings={showNewEarnings}
          firstChild={i === 0}
          lastChild={i === earnings.length - 1}
        />
      );
    });

    const placeholderText = (
      <PlaceholderText>
        You have no followed colleges that match &quot;{earningFilter}&quot;
      </PlaceholderText>
    );

    return (
      <div key="earnings" className="college-earnings-scroll">
        <FollowingHeader
          followCount={(followedCollegeIds || []).length}
          {...{setEarningFilter, earningFilter}}
        />
        {earnings.length ? earningNodes : placeholderText}
        {earningFilter !== 'not earning' && (followedCollegeIds || []).length < 6 && (
          <DiscoverCollegesButton />
        )}
      </div>
    );
  }
}

export default CollegeEarnings;
